/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs'

const $nsid = 'app.bsky.feed.getActorFeeds'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  actor: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  feeds: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<FeedDefs.GeneratorView>(
      (() => FeedDefs.generatorView) as any,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get a list of feeds (feed generator records) created by the actor (in the actor's repo). */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
